import PageHeading from '../../shared/components/UIElements/PageHeading';
import EmptyState from '../../shared/components/UIElements/EmptyState';
import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../shared/Context/auth-context';
import './PharmacyPrescription.css';
import Card from '../../shared/components/UIElements/Card';
import { BACKEND_URL } from '../../shared/util/backend-url';

const PharmacyPrescriptions = () => {
  const auth = useContext(AuthContext);
  const [prescriptions, setPrescriptions] = useState([]);

  useEffect(() => {
    const fetchPrescriptions = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/pharmacy/${auth.pharmacyId}`, {
          headers: {
            Authorization: `Bearer ${auth.token}`
          }
        });

        const data = await response.json();
        setPrescriptions(data.prescriptions || []);
      } catch (err) {
        console.error('Error fetching prescriptions:', err);
      }
    };

    if (auth.pharmacyId) fetchPrescriptions();
  }, [auth.pharmacyId, auth.token]);

  return (
    <div className="pharmacy-prescription">
      <PageHeading
        eyebrow="PRESCRIPTION INBOX"
        title="Received prescriptions"
        description="Review the prescriptions shared with your pharmacy."
      />
      <Card className="pharmacy-dashboard__card">
        {prescriptions.length === 0 ? (
          <EmptyState title="Your inbox is clear">
            Prescriptions shared by doctors will appear here.
          </EmptyState>
        ) : (
          prescriptions.map((pres, index) => (
            <div key={index} className="prescription-card">
              <h4>
                Patient: {pres.patientName} ({pres.age} yrs, {pres.sex})
              </h4>
              <p>
                <strong>Diagnosis:</strong> {pres.diagnosis}
              </p>
              <p>
                <strong>Vitals:</strong> {pres.vitals}
              </p>
              <p>
                <strong>Remarks:</strong> {pres.remarks}
              </p>
              <p>
                <strong>Prescribed by:</strong> {pres.doctor.name} ({pres.doctor.specialization})
              </p>
              <ul className="medication-list">
                {pres.doctor.signature && (
                  <img
                    src={`${BACKEND_URL}/${pres.doctor.signature}`}
                    alt="Doctor Signature"
                    className="signature-img"
                  />
                )}
                {pres.medications.map((m, i) => (
                  <li key={i}>
                    <strong>{m.name}</strong> - {m.dose}, {m.frequency}, {m.duration}
                  </li>
                ))}
              </ul>
              <p className="timestamp">{new Date(pres.createdAt).toLocaleString()}</p>

              <div className="prescription-actions">
                <button className="check-btn" onClick={() => console.log('Checked:', pres._id)}>
                  Check
                </button>
                <button
                  className="dispatch-btn"
                  onClick={() => console.log('Dispatched:', pres._id)}
                >
                  Dispatch
                </button>
              </div>
            </div>
          ))
        )}
      </Card>
    </div>
  );
};

export default PharmacyPrescriptions;
